/* RESPONSIBLE TEAM: team-standalone */

import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type { IntegrationWarningReason } from 'embercom/components/knowledge-hub/conversational/standalone/integration-warning';
import type Platform from '../platform';
import type { StandalonePlatform } from '../../constants';
import type { TemplateCardType } from 'embercom/lib/ai-content-library/constants';
import type { Action } from 'embercom/components/common/hero-banner';

export interface ConversationExtractionRowData {
  icon: InterfaceIconName;
  title: string;
}

export interface KnowledgeHubModalData {
  integrationWarning: IntegrationWarningReason | null;
  settingsBlockedReason: string;
}

export interface ConversationExcerptData {
  title: (excerptsEnabled: boolean) => string;
  link: string | undefined;
}

export abstract class OnboardingGuideStepData {
  protected platform: Platform;

  constructor(platform: Platform) {
    this.platform = platform;
  }

  abstract titleKey(stepIdentifier: string): string;
  abstract descriptionKey(stepIdentifier: string): string;
  abstract ctaKey(stepIdentifier: string): string;
  abstract secondaryCTAKey(stepIdentifier: string): string;
  abstract get platformName(): string;
  abstract moreInfoLinkLabel(stepIdentifier: string): string | null;
  abstract moreInfoArticleId(stepIdentifier: string): number | undefined;
  abstract shouldShowConnectDrawer(stepIdentifier: string): boolean;
}

export interface RequestAccessData {
  platformUrl: string | undefined;
  platformName: StandalonePlatform;
  imageUrl: string;
}

export interface CommonPrimaryNavBarData {
  navItemTranslationKey: string;
  icon: InterfaceIconName;
}
export abstract class ChannelTargetingBodyData {
  abstract get addMessengerChannel(): boolean;
  abstract get channelGroupTitleKey(): string;
  abstract get channels(): {
    value: string;
    icon: InterfaceIconName;
    requiresAppStoreInstallation: boolean;
    channelTypeValue: string;
    isSetup: boolean;
  }[];
}

export interface AiContentLibraryData {
  templates: Array<TemplateCardType>;
}

export interface KnowledgeContentData {
  heroBannerActions: Array<Action>;
}

// This data is used in the content sources tooltip in the Copilot composer
// E.g. "[zendesk icon] Historical tickets"
export interface ComposerOverflowMenuTooltipData {
  icon: InterfaceIconName;
  entityNameKey: string;
  historicalCasesDisabledTooltipKey: string;
}

// This data is used in the example code snippets in the Installation New page
// E.g. "In Zendesk, ensure that each user has a unique external_id, typically their user_id or email"
export interface ExampleCodeSnippetData {
  userIdInstallationInstructionKey: string;
}

// This data is used in the conversation ingestion side drawer
export interface ConversationIngestionData {
  drawerTitle: string;
  syncHistoryTitle: string;
  syncTicketHistoryLabel: string;
  disableSyncBody: string;
  importingEnabledNotificationMessage: string;
  deployCopilotRoute: string;
}
